import ProjectSession from "../../../../model2/project/project-session";
import ItemId from "../../../id/item-id";
import Pin from "../../../../gd-components/pin/v2/pin";
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../gd-components/buttons/control-button/control-button-standard";
import React, {useState} from "react";
import StarProjectControl from "../../../../gd-components/star/star";
import ControlShowInProjectsTree from "../../../../gd-app/component/quick-links/aim";


type Props = {
    project         : ProjectSession
    hidePopover     : callback
}

export default function MoreProject_PopoverMenuTop(props:Props) {

    const [renderCount, reRender] = useState(0);

    const onClickOpenNewWindow = () => {
        // props.hidePopover()
        gd.layout.popovers.closeAll()

        props.project.openNewWindow()
    }

    const onClickCopyLink = () => {
        // props.hidePopover()
        gd.layout.popovers.closeAll()

        props.project.copyUrl()
    }

    const refresh = () => {

        // new
        gd.layout.popovers.closeAll()

        // old
        // reRender(renderCount+1)
    }

    const canPinStar = props.project.properties.availableMenuOptions.pinStar

    return (
        <div className="flex-row-between-center h-36 m-t-5 p-l-20 p-r-10">

            <ItemId itemId={props.project.id}
                    itemUrl="p/"
                    itemUrlId={props.project.id}
                    itemName="Resource"
                    copyId={true}
                    copyUrl={false}/>

            <div className="flex-row-center-center">

                {canPinStar &&
                    <>
                        <Pin data={{projectId: props.project.id}}/>

                        <StarProjectControl project={props.project} callback={refresh} className="m-l-5" />
                    </>
                }

                <ControlButtonStandard className="m-l-5"
                                       type={ControlButtonType.LINK}
                                       hint="Copy link"
                                       onClick={onClickCopyLink}/>

                <ControlButtonStandard className="m-l-5"
                                       type={ControlButtonType.OPEN_IN_BROWSER}
                                       hint="Open in new window"
                                       onClick={onClickOpenNewWindow}/>

                <ControlShowInProjectsTree project={props.project} className="m-l-5" />

            </div>
        </div>
    )


}
